import React from 'react'
import ErrorSuccessModal from '../ErrorSuccessModal/ErrorSuccessModal';
import { connect } from 'react-redux';
import { resetClientSettingsError, resetClientSettingsSuccess } from '../../../redux/clientSettings';
import { resetSession } from '../../../redux/auth';
import { RootState } from '../../../redux/rootReducers';

type AppProps = {
  fetching: boolean;
  success: number | null;
  error: string | null;
  statusCode: number | null;

  dispatchResetSession: () => void;
  dispatchResetClientSettingsError: () => void;
  dispatchResetClientSettingsSuccessAction: () => void;

};
const FileUploadErrorModal = ({
    fetching,
    success,
    error,
    dispatchResetSession,
    dispatchResetClientSettingsError,
    dispatchResetClientSettingsSuccessAction,
    statusCode
}:AppProps) => {
    const handleErrorModal = () => {
        if (success === 0) {
          if (statusCode === 401) {
            return (
              <ErrorSuccessModal
                type="error"
                isOpen={!!error}
                title="Error"
                message="Session Expired. Please Login Again!"
                buttonText="Logout"
                onPress={() => dispatchResetSession()}
                statusCode={statusCode}
              />
            );
          } else if (error && statusCode !== 401) {
            return (
              <ErrorSuccessModal
                type="error"
                isOpen={!!error}
                title="Error"
                message={error}
                buttonText="OK"
                onPress={() => {
                  dispatchResetClientSettingsError();
                }}
              />
            );
          }
        }
    
        
    
        return false;
      };
  return (
    <>
      {handleErrorModal()}
    </>
  )
}

const mapStateTopProps = (state: RootState) => ({
  error: state.clientSettings.multipleFileUploadError,
  statusCode: state.clientSettings.statusCode,
  success: state.clientSettings.multipleFileUploadSuccess,
  fetching: state.clientSettings.multipleFileUploadFetching,
 
});

const mapDispatchToProps = (dispatch: any) => ({

  dispatchResetSession: () => dispatch(resetSession()),

  dispatchResetClientSettingsError: () => dispatch(resetClientSettingsError()),
  dispatchResetClientSettingsSuccessAction: () =>
    dispatch(resetClientSettingsSuccess()),


});
export default connect(mapStateTopProps, mapDispatchToProps)(FileUploadErrorModal);
